import {useEffect} from 'react'
import Select from '../../../../common/components/Select.js'
import {shipperCarrierOptionsSelector} from '../../../../data/shippers.js'
import {useSelector} from '../../../../store.js'
import {
  scanFormModalFormSelector,
  updateScanFormForm,
} from './scanFormModalFunctions.js'
import WarehouseSelect from './WarehouseSelect.js'

export default function ShippoManifestPanel() {
  const {shipperID, carrierAccountID} = useSelector(scanFormModalFormSelector)
  const shipperCarrierOptions = useSelector((state) =>
    shipperCarrierOptionsSelector(state, {shipperID}),
  )

  useEffect(() => {
    if (
      shipperCarrierOptions.length &&
      (!carrierAccountID ||
        !shipperCarrierOptions.find(({value}) => value === carrierAccountID))
    ) {
      updateScanFormForm({carrierAccountID: shipperCarrierOptions[0].value})
    }
  }, [carrierAccountID, shipperCarrierOptions])

  return (
    <>
      <Select
        className="margin-bottom-15"
        id="shipper_manifest_carrier_account_id"
        label="Carrier Account"
        value={carrierAccountID}
        onChange={(carrierAccountID) => updateScanFormForm({carrierAccountID})}
        options={shipperCarrierOptions}
      />
      <WarehouseSelect />
    </>
  )
}
